//import {axiosGet} from '../../../app/Helpers/AxiosHelper';

export default {

    state: {
        dashboardThemeConfiguration:{}
    },

    getters: {
        getDashBoardThemeConfiguration: state => state.dashboardThemeConfiguration
    },

    mutations: {
        SET_GHL_CUSTOMIZATION_CONFIG(state, data){
            state.dashboardThemeConfiguration = data;
        }
    },

    actions: {
        setDaashboardCustomizationTheme({commit},data){
            commit('SET_GHL_CUSTOMIZATION_CONFIG', data);
        }
    }
}
